// import { UserService } from './users'
import {
    AllSaleStatAPIRepository,
    ApikeyAPIRepository,
    CalculatePriceAPIRepository,
    CustomerAPIRepository,
    SaleAPIRepository,
    SaleStatAPIRepository,
    SaleCustomerStatAPIRepository,
    CustomerStatAPIRepository,
    GoogleMapRepository,
} from "@/repositories";
import { BasketAPIRepository } from "@/repositories/basket";
import { DraftOrderAPIRepository } from "@/repositories/draftOrder";
import { OrderAPIRepository } from "@/repositories/order/api";
import { SearchAPIRepository } from "@/repositories/search";
import { AuthenticationService } from "./authentication";
import { BasketService } from "./basket";
import { CalculatePriceService } from "./calculatePrice";
import { Catalog } from "./catalog";
import { CustomerService } from "./customers";
import { DraftOrderService } from "./draftOrder";
import { OrderService } from "./order";
import { IProvider } from "./provider.types";
import { SaleService } from "./sales";
import { SearchService } from "./search";
import { PayService } from "./pay";
import { PayAPIRepository } from "@/repositories/pay/api";
import { PolygonService } from "./polygon";
import { PolygonAPIRepository } from "@/repositories/polygon";
import { DeliverySlotAPIRepository } from "@/repositories/deliverySlot";
import { DeliverySlotService } from "./deliverySlot";
import { RequestToPayService } from "./requestToPay";
import { RequestToPayAPIRepository } from "@/repositories/requestToPay";
import { AdminAPIRepository } from "@/repositories/admin";
import { AdminService } from "./admin";
import { SaleStatService } from "./saleStat";
import { AdminStatService } from "./adminStat";
import { AllSaleStatService } from "./allSaleStat";
import { SaleCustomerStatService } from "./saleCustomerStat";
import { CustomerStatService } from "./customerStat";
import { APIKeyService } from "./apikey"
import { GoogleMapService } from "./googlemap";

// import { TradingAccountService } from './tradingAccounts/tradingAccounts';
// import { TradingAccountInMemoryRepository } from '@/repositories/tradingAccounts';
// import { mockTradingAccountData } from '@/entities/tradingAccount';
// import { TradingAccountAPIRepository } from '@/repositories/tradingAccounts/api';
// import { BotService } from './bots/bots';
// import { BotAPIRepository } from '@/repositories/bots';
// import { BotTickerService } from './botTickers/botTickers';
// import { BotTickerAPIRepository } from '@/repositories/botTickers';
// import { DealService } from './deals/deals';
// import { DealAPIRepository } from '@/repositories/deals';

const saleRepository = new SaleAPIRepository();
const apikeyRepository = new ApikeyAPIRepository();
const basketRepository = new BasketAPIRepository();
const orderRepository = new OrderAPIRepository();
const searchRepository = new SearchAPIRepository();
const customerRepository = new CustomerAPIRepository();
const calculatePriceRepository = new CalculatePriceAPIRepository();
const draftOrderRepository = new DraftOrderAPIRepository();
const payRepository = new PayAPIRepository();
const polygonRepository = new PolygonAPIRepository();
const deliverySlotRepository = new DeliverySlotAPIRepository();
const requestToPayRepository = new RequestToPayAPIRepository();
const adminRepository = new AdminAPIRepository();
const statRepository = new SaleStatAPIRepository();
const allSaleStatRepository = new AllSaleStatAPIRepository();
const saleCustomerStatAPIRepository = new SaleCustomerStatAPIRepository();
const customerStatAPIRepository = new CustomerStatAPIRepository();
const googleMapRepository = new GoogleMapRepository();
// const customerRepository = new CustomerAPIRepository();
// const tradingAccountRepository = new TradingAccountAPIRepository();
// const botRepository = new BotAPIRepository();
// const botTickerRepository = new BotTickerAPIRepository();
// const dealRepository = new DealAPIRepository();
// const tradingAccountRepository = new TradingAccountInMemoryRepository(mockTradingAccountData());

export const provider = (): IProvider => ({
    sales: new SaleService(saleRepository),
    catalog: new Catalog(),
    authentication: new AuthenticationService(apikeyRepository),
    baskets: new BasketService(basketRepository),
    orders: new OrderService(orderRepository),
    search: new SearchService(searchRepository),
    customers: new CustomerService(customerRepository),
    calculatePrice: new CalculatePriceService(calculatePriceRepository),
    draftOrders: new DraftOrderService(draftOrderRepository),
    pay: new PayService(payRepository),
    polygon: new PolygonService(polygonRepository),
    deliverySlot: new DeliverySlotService(deliverySlotRepository),
    requestToPay: new RequestToPayService(requestToPayRepository),
    admin: new AdminService(adminRepository),
    stat: new SaleStatService(statRepository),
    adminStat: new AdminStatService(statRepository),
    allSaleStat: new AllSaleStatService(allSaleStatRepository),
    saleCustomerStat: new SaleCustomerStatService(
        saleCustomerStatAPIRepository
    ),
    customerStat: new CustomerStatService(customerStatAPIRepository),
    apikey: new APIKeyService(apikeyRepository),
    googlemap: new GoogleMapService(googleMapRepository),
    //   users: new UserService(userRepository),
    //   tradingAccounts: new TradingAccountService(tradingAccountRepository),
    //   bots: new BotService(botRepository),
    //   botTickers: new BotTickerService(botTickerRepository),
    //   deals: new DealService(dealRepository)
});
